/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Input_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Type a caption line and press Enter" |
*
* @param {Live_Caption_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_input_placeholder = /** @type {((inputs?: Live_Caption_Input_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Input_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez une légende et appuyez sur Entrée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie eine Bildunterschrift ein und drücken Sie die Eingabetaste.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Digita una didascalia e premi Invio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите подпись и нажмите Enter.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escriba una línea de pie de foto y pulse Intro.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入标题并按回车键")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションの行を入力してEnterキーを押してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन की एक पंक्ति टाइप करें और एंटर दबाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Digite uma legenda e pressione Enter.")
	return /** @type {LocalizedString} */ ("Type a caption line and press Enter")
});